<template>
  <md-list class="md-layout md-alignment-space-around-space-between">
    <div>
      <router-link :to="{name: 'MapInitial'}">
        <div class="md-alignment-center">
          <img src="https://cdn.jon-api.com/shikaku-map/img/logo-s.png">
        </div>
      </router-link>
      <md-divider></md-divider>
      <to-contract-button :is-button="false"
                          v-if="!initLoading && isTrialUser && isSuperUser()"></to-contract-button>
      <router-link :to="{name: 'BackendUserRequestHistories'}" tag="md-list-item"
                   class="md-list-item-auto"
                   v-if="!initLoading">
        <md-icon>playlist_play</md-icon>
        <span class="md-list-item-text">取得履歴</span>
      </router-link>
      <router-link :to="{name: 'BackendUserUsage'}" tag="md-list-item"
                   class="md-list-item-auto"
                   v-if="!initLoading">
        <md-icon>import_export</md-icon>
        <span class="md-list-item-text">利用状況</span>
      </router-link>
      <router-link tag="md-list-item" :to="{name: 'BackendUserNotifications'}"
                   :class="activeRouteClass(['BackendUserNotifications', 'BackendUserNotificationDetail'])"
                   class="md-list-item-auto"
                   v-if="!initLoading">
        <md-icon>warning</md-icon>
        <span class="md-list-item-text">お知らせ</span>
      </router-link>
      <router-link :class="activeRouteClass(['BackendUserBillings', 'BackendUserBillingDetail'])" :to="{name: 'BackendUserBillings'}"
                   class="md-list-item-auto"
                   tag="md-list-item"
                   v-if="!initLoading && !isTrialUser && isSuperUserOrGroupAdmin() && showMenuByExpandEtc()">
        <md-icon>description</md-icon>
        <span class="md-list-item-text">請求管理</span>
      </router-link>
      <router-link :class="activeRouteClass(['BackendUserPayments', 'BackendUserPaymentNew'])" :to="{name: 'BackendUserPayments'}"
                   class="md-list-item-auto"
                   tag="md-list-item"
                   v-if="!initLoading && !isTrialUser && isSuperUserOrGroupAdmin() && showMenuByExpandEtc()">
        <md-icon>payment</md-icon>
        <span class="md-list-item-text">支払方法管理</span>
      </router-link>
      <router-link :class="activeRouteClass(['BackendUserDepartments', 'BackendUserDepartmentNew', 'BackendUserPaymentMethod'])" :to="{name: 'BackendUserDepartments'}"
                   class="md-list-item-auto"
                   tag="md-list-item"
                   v-if="!initLoading && !isTrialUser && isSuperUserOrGroupAdmin() && showMenuByExpandEtc()">
        <md-icon>reorder</md-icon>
        <span class="md-list-item-text">部門管理</span>
      </router-link>
      <router-link :class="activeRouteClass(['BackendUsers', 'BackendUserNew', 'BackendUserEdit'])" :to="{name: 'BackendUsers'}"
                   class="md-list-item-auto"
                   tag="md-list-item"
                   v-if="!initLoading && !isTrialUser && isSuperUserOrGroupAdmin() && showMenuByExpandEtc()">
        <md-icon>supervised_user_circle</md-icon>
        <span class="md-list-item-text">ユーザー管理</span>
      </router-link>
      <router-link tag="md-list-item" :to="{name: 'BackendUserSetting'}"
                   :class="activeRouteClass(['BackendUserSetting', 'BackendUserDeactivate'])"
                   class="md-list-item-auto"
                   v-if="!initLoading">
        <md-icon>settings</md-icon>
        <span class="md-list-item-text">アカウント管理</span>
      </router-link>
    </div>
    <div>
      <md-list-item :class="expandEtc ? '' : 'md-list-item-auto'" :md-expanded.sync="expandEtc" md-expand>
        <md-icon>subject</md-icon>
        <span class="md-list-item-text">利用規約 他</span>
        <md-list class="md-expand-items" slot="md-expand">
          <md-list-item class="md-inset">
            <a href="/terms" rel="noopener" tag="md-button" target="_blank">利用規約</a>
          </md-list-item>
          <md-list-item class="md-inset">
            <a href="https://www.jon.co.jp/privacy/" rel="noopener" tag="md-button" target="_blank">個人情報保護方針</a>
          </md-list-item>
          <md-list-item class="md-inset">
            <a href="/legal" rel="noopener" tag="md-button" target="_blank">特定商取引法に基づく表記</a>
          </md-list-item>
          <md-list-item class="md-inset">
            <a href="/payment" rel="noopener" tag="md-button" target="_blank">ご利用上の注意</a>
          </md-list-item>
        </md-list>
      </md-list-item>
      <md-list-item class="md-list-item-auto">
        <md-icon>poll</md-icon>
        <a class="anchor md-layout md-alignment-center-left" href="/simulation2" rel="noopener" target="_blank">
          <span class="md-list-item-text">料金シミュレーション</span>
        </a>
      </md-list-item>
      <md-list-item class="md-list-item-auto">
        <md-icon>question_answer</md-icon>
        <a class="anchor md-layout md-alignment-center-left" href="/faq" rel="noopener"
           target="_blank">
          <span class="md-list-item-text">お問い合わせ・FAQ</span>
        </a>
      </md-list-item>
      <router-link tag="md-list-item" :to="'#'" @click.native="logOutUser">
        <md-icon>logout</md-icon>
        <span class="md-list-item-text">ログアウト</span>
      </router-link>
    </div>
  </md-list>
</template>

<script>
import Common                                         from '../../../modules/common';
import CommonMixin                                    from "../../../mixins/commonMixin";
import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
import ToContractButton                               from "../../trial/ToContractButton";

export default {
    name   : "UserSidebar",
    components: {ToContractButton},
    mixins : [CommonMixin],
    data() {
      return {
        initLoading: true,
        isTrialUser: false,
      }
    },
    created() {
      this.initDisplay();
      this.getWindowInnerSize();
      window.addEventListener('resize', this.getWindowInnerSize);
    },
    methods: {
      initDisplay() {
        apiClient.get(apiList.accounts.status)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }

            this.isTrialUser = [Common.trialStatus, Common.trialEndedStatus].includes(response.data.status);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.initLoading = false;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .md-expand-items {
    margin-bottom: 8px;

    ::v-deep(.md-list-item.md-inset) {
      .md-list-item-content {
        min-height: 24px;
        font-size: 0.7rem;
      }
    }
  }

  .md-app-side-drawer {
    a {
      color: rgba(0, 0, 0, 0.87);
    }
  }

  @media (max-height: 680px) {
    .md-list-item-auto {
      height: calc((100dvh - 90px) / 12);
    }
  }
</style>
